import * as R from "ramda";

import {
  generateItemsReducer,

  generateItemAndActionsFromStore,
  generateItemListAndActionsFromStore,
  generateStateActions,
} from "./item";

const itemType = "documentUserState";
const endpoint = "document_user_states/";

export const documentUserStatesReducer = generateItemsReducer<DocumentUserStateSnakeModel, {}>(itemType);

function documentUserStateMergeFunction(rawItem: ItemStateLoaded<DocumentUserStateSnakeModel, {}>): DocumentUserStateSnakeModel {
  return {
    ...rawItem.savedData,
    ...rawItem.editData,
    state: R.mergeDeepRight(rawItem.savedData.state, rawItem.editData?.state || {}),
  };
}

export const documentUserStateAndActionsFromStore = generateItemAndActionsFromStore<DocumentUserStateSnakeModel, {}, ItemStateActions>(
  itemType,
  endpoint,
  generateStateActions,
  documentUserStateMergeFunction,
);

export const documentUserStateListAndActionsFromStore = generateItemListAndActionsFromStore(itemType, documentUserStateAndActionsFromStore);
